/* eslint-disable @typescript-eslint/naming-convention */

import { BrandingColorMap } from '../../branding-color-map.interface';

export const BRANDING_COLOR_MAP_AAR: BrandingColorMap = {
  'primary-100': '#FFD9B4',
  'primary-200': '#FFBF80',
  'primary-400': '#FF7900',
  'primary-600': '#FF7900',
  'primary-800': '#FF7900',
};
